import React, { useEffect, useState, useContext } from 'react';
import './aboutPage.scss'; 
import { LanguageContext } from '../../services/LanguageContext'; // Import LanguageContext
import { translateText } from '../../services/deeplTranslationService'; // Import translation service

const AboutPage = () => {
    const { language } = useContext(LanguageContext); // Get the selected language from context
    const [aboutUs, setAboutUs] = useState(null);
    const [loading, setLoading] = useState(true);
    const [translatedTitle, setTranslatedTitle] = useState('');
    const [translatedDescription, setTranslatedDescription] = useState('');

    useEffect(() => {
        // Fetch About Us data from the API
        const fetchAboutUs = async () => {
            try {
                const response = await fetch('https://find-together-api.sslbeta.de/api/Support/getAboutUs');
                const data = await response.json();
                setAboutUs(data[0]); // Assuming the API returns an array and we take the first item
                
                // If language is not German, translate the content
                if (language !== 'DE') {
                    const translatedTitle = await translateText(data[0].title, language);
                    const translatedDescription = await translateText(data[0].description, language);
                    setTranslatedTitle(translatedTitle);
                    setTranslatedDescription(translatedDescription);
                } else {
                    // If language is German, don't translate, use original
                    setTranslatedTitle(data[0].title);
                    setTranslatedDescription(data[0].description);
                }
            } catch (error) {
                console.error('Error fetching About Us:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAboutUs();
    }, [language]);

    return (
        <div className='container inner-page-container'>
            {loading ? (
                <p className='text-center'>Loading About Us...</p>
            ) : (
                aboutUs && (
                    <div className='about-us-content'>
                        {aboutUs.imageUrl && (
                            <div
                                className='cover-image'
                                style={{ backgroundImage: `url(${aboutUs.imageUrl})` }}
                            />
                        )}
                        <h2 className='text-left my-5'>{translatedTitle}</h2>
                        {/* Render HTML description */}
                        <div
                            className="about-description"
                            dangerouslySetInnerHTML={{ __html: translatedDescription }}
                        />
                    </div>
                )
            )}
        </div>
    );
};

export default AboutPage;
